import parseISO from 'date-fns/parseISO';

export default function isoDateToString(isoDate, locale, dateOptions) {
  if (!isoDate) {
    return null;
  }

  const date = typeof isoDate === 'string' ? parseISO(isoDate) : isoDate;

  if (!date.toLocaleDateString) {
    return date.toDateString();
  }

  return date.toLocaleDateString(locale, dateOptions);
}
